import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import FormField from "../../../utils/FormField";
import { getProvinces, getDistricts, getWards, loginUser } from "../../../redux/actions/user_actions";
import { getCategories } from "../../../redux/actions/products_actions";
import { update, generateData, ifFormValid } from "../../../utils/FormAction";
import { withRouter, Link } from "react-router-dom";
import {
    Button,
    Card,
    Form,
    Container,
    Row,
    Col,
  } from "reactstrap";
import NProgress from 'nprogress';
import { HOST_URL } from "../../../utils/misc.js";
import Swal from 'sweetalert2'

const Login = (props) => {

  const state = {
    formError: false,
    formSuccess: "",
    formData: {
      email: {
        element: "input",
        value: "",
        config: {
          name: "email_input",
          type: "email",
          placeholder: "Email...",
        },
        validation: {
          required: true,
          email: true,
        },
        valid: false,
        touched: false,
        validationMessage: "",
      },
      password: {
        element: "input",
        value: "",
        config: {
          name: "password_input",
          type: "password",
          placeholder: "Mật khẩu...",
        },
        validation: {
          required: true,
        },
        valid: false,
        touched: false,
        validationMessage: "",
      },
    },
  };

  const [input, setInput] = useState(state);

  useEffect(() => {
    window.scrollTo(0, 0)
    NProgress.done();
    if(JSON.parse(localStorage.getItem("user")) != null) {
      props.history.push("/home")
    }
  }, [])

  const updateForm = async (element) => {
    const newFormData = update(element, input.formData, "login");
    const newFormData_Input = {
      formError: false,
      formData: newFormData,
    };
    await setInput(newFormData_Input);
  };

  const submitForm = async (event) => {
    event.preventDefault();

    let dataToSubmit = generateData(input.formData, "login");
    let formIsValid = ifFormValid(input.formData, "login");

    if (formIsValid) {
      props.dispatch(loginUser(dataToSubmit)).then((res) => {
        if (res.payload.user.success) {     
          if(res.payload.user.data.userData.customerId){
            handleThenLogin()
          }
          else {
            Swal.fire({
              title: 'Đăng nhập thất bại!',
              text: 'Sai tên đăng nhập hoặc mật khẩu',
              icon: 'warning',
              confirmButtonText: 'Đóng',
              confirmButtonColor: '#000000',
            })
          }
        } 
        else {
          setInput((preState) => ({
            ...preState,
            formError: true,
          }));
          Swal.fire({
            title: 'Đăng nhập thất bại!',
            text: 'Sai tên đăng nhập hoặc mật khẩu',
            icon: 'warning',
            confirmButtonText: 'Đóng',
            confirmButtonColor: '#000000',
          })
        }
      });
    } else {
      await setInput((preState) => ({
        ...preState,
        formError: true,
      }));
    }
  };

  const handleThenLogin=()=>{
    let userInfo = JSON.parse(localStorage.getItem("user"))
    // Get User Info
    props.dispatch(getProvinces())
    props.dispatch(getDistricts(userInfo.provinceId))
    props.dispatch(getWards(userInfo.districtId))
    props.dispatch(getCategories())
    // Check Account
    if(userInfo.roleName == "admin"){      
      return(
        Swal.fire({
          title: 'Đăng nhập thành công!',
          text: '',
          icon: 'success',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#000000',
        }
        ).then((ok)=>{
            if(ok){
              props.history.push("/admin")
            }
        })   
      )      
    }

    if(props.cart.carts && props.cart.carts.length > 0) {
      Swal.fire({
        title: 'Đăng nhập thành công!',
        text: 'Trở về giỏ hàng',
        icon: 'success',
        confirmButtonText: 'Đóng',
        confirmButtonColor: '#000000',
      }
      ).then((ok)=>{
          if(ok){
            props.history.push("/confirm")
          }
      })   
    }
    else{
      Swal.fire({
        title: 'Đăng nhập thành công!',
        text: 'Trở về trang mua hàng',
        icon: 'success',
        confirmButtonText: 'Đóng',
        confirmButtonColor: '#000000',
      }
      ).then((ok)=>{
          if(ok){
            //Scroll to top
            window.scrollTo(0, 0)
            props.history.push("/home")
          }
      })  
    }
  }

  return (
    <>
      <div
        className="section section-image section-login"
        style={{
          backgroundImage: `url(${HOST_URL + props.templates.templates.templateProperties.image_registerpage})`, minHeight:950
        }}
      >
        <Container style={{ marginTop:150 }}>
          <Row>
            <Col className="mx-auto" lg="4" md="6">
              <Card className="card-register" style={{ minWidth:300 }}>
                <h3 className="title mx-auto">Đăng Nhập</h3>
                <Form className="register-form" onSubmit={(event) => submitForm(event)}>
                  <label>Email</label>
                    <div>
                      <FormField
                        id={"email"}
                        formData={input.formData.email}
                        change={(element) => updateForm(element)}
                      />
                    </div>
                  <label>Mật Khẩu</label>
                    <div>
                      <FormField
                        id={"password"}
                        formData={input.formData.password}
                        change={(element) => updateForm(element)}
                      />
                    </div>
                    <div className="text-right" style={{ marginTop:10}}>
                      <Link to={`/register`} style={{ color:"#FFFFFF", padding:0 }}><b>Bạn chưa có tài khoản?</b></Link>
                    </div>
                  <Button
                    block
                    className="btn-round"
                    color="default"
                    type="button"
                    style={{ marginTop:10 }}
                    onClick={(event) => submitForm(event)}
                  >
                    Xác Nhận
                  </Button>
                </Form>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>{" "}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Login);